import React, { useState, useEffect, useRef } from "react";
import "./FormCompra.css";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { hashUserData, setUserData } from "../../metaPixel";

export default function CheckoutForm() {

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const kit = params.get("kit");
  const preco = params.get("preco");
  const description = params.get("description");

  const [compraId] = useState(
    "pedido_" + Date.now() + "_" + Math.floor(Math.random()*100000)
  );

  const [loadingCep,setLoadingCep] = useState(false);
  const [submitting,setSubmitting] = useState(false);
  const [error,setError] = useState("");

  const [form,setForm] = useState({
    nome:"",
    celular:"",
    email:"",
    cpf:"",
    cep:"",
    endereco:"",
    numero:"",
    bairro:"",
    cidade:"",
    estado:""
  });

  useEffect(() => {
    if (window.fbq && preco) {
      window.fbq('track', 'InitiateCheckout', {
        value: parseFloat(String(preco).replace(',', '.')),
        currency: 'BRL',
        content_name: description || kit,
      });
    }
  }, [preco, kit, description]);

  const estados = [
    "AC","AL","AP","AM","BA","CE","DF","ES","GO",
    "MA","MT","MS","MG","PA","PB","PR","PE","PI",
    "RJ","RN","RS","RO","RR","SC","SP","SE","TO"
  ];

  const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzRpTEbdM6dzZwK7v_48aEJjNVivn-auestSaWDHNebj8kI73yW2CE9aZMihb8Wt-_g/exec";

  const CLOUD_RUN_URL =
  "https://gerador-pagamentos-mercadopago-288487630160.us-east1.run.app";

  function mascaraCEP(v){
    v=v.replace(/\D/g,'');
    v=v.replace(/^(\d{5})(\d)/,"$1-$2");
    return v.slice(0,9);
  }

  function mascaraCPF(v){
    v=v.replace(/\D/g,'');
    v=v.replace(/(\d{3})(\d)/,"$1.$2");
    v=v.replace(/(\d{3})(\d)/,"$1.$2");
    v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2");
    return v.slice(0,14);
  }

  function mascaraCelular(v){
    v=v.replace(/\D/g,'');
    v=v.replace(/^(\d{2})(\d)/g,"($1) $2");
    v=v.replace(/(\d{5})(\d)/,"$1-$2");
    return v.slice(0,15);
  }

  const buscarCEP = async (cep) => {

    const cepLimpo = cep.replace(/\D/g,'');

    if(cepLimpo.length!==8) return;

    setLoadingCep(true);

    try{

      const res = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await res.json();

      if(!data.erro){

        setForm(prev => ({
          ...prev,
          cep:mascaraCEP(cepLimpo),
          endereco:data.logradouro || "",
          bairro:data.bairro || "",
          cidade:data.localidade || "",
          estado:data.uf || ""
        }));

      }

    }catch(e){}

    setLoadingCep(false);
  }

  function handleChange(e){

    let {name,value} = e.target;

    if(name==="cep"){
      value=mascaraCEP(value);
      buscarCEP(value);
    }

    if(name==="cpf") value=mascaraCPF(value);
    if(name==="celular") value=mascaraCelular(value);

    setForm(prev => ({
      ...prev,
      [name]:value
    }));

  }

  const pedidoRegistrado = useRef(false);
  const [pix,setPix] = useState(null);
  const [copiado,setCopiado] = useState(false);

  function validar(metodo){
    if(form.celular.replace(/\D/g,'').length!==11){
      return "Informe um celular válido com DDD, ex.: (19) 99999-1111.";
    }
    if(metodo==="pix" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())){
      return "Informe um e-mail válido para gerar o Pix.";
    }
    return "";
  }

  // Registra o pedido na planilha (uma vez só, mesmo que o cliente troque de forma de pagamento)
  async function registrarPedido(){
    if(pedidoRegistrado.current) return;

    const payload = {
      ...form,
      compra_id: compraId,
      kit: kit,
      preco: preco,
      description: description,
      new_sell: true
    };

    const formData = new FormData();

    Object.entries(payload).forEach(([key,value])=>{
      formData.append(key,value);
    });

    const res1 = await fetch(SCRIPT_URL,{
      method:"POST",
      body: formData
    });

    if(!res1.ok){
      throw new Error("Erro ao registrar pedido.");
    }

    pedidoRegistrado.current = true;
  }

  // Guarda o pedido no navegador para o Pixel registrar a compra na página de sucesso
  async function guardarPedidoPixel(){
    try {
      let ud = null;
      try {
        ud = await hashUserData(form);
        setUserData(ud);
      } catch(e){}
      localStorage.setItem("vf_pedido_" + compraId, JSON.stringify({ preco, kit, description, ud }));
    } catch(e){}
  }

async function handleSubmit(metodo){

  if(submitting) return;

  const erroValidacao = validar(metodo);
  if(erroValidacao){
    setError(erroValidacao);
    return;
  }

  setError("");
  setSubmitting(metodo);

  try {

    await registrarPedido();

    if(metodo==="pix"){

      const resPix = await fetch(CLOUD_RUN_URL,{
        method:"POST",
        headers:{ "Content-Type":"application/json" },
        body: JSON.stringify({
          acao: "pix",
          description,
          preco,
          compra_id: compraId,
          email: form.email,
          nome: form.nome,
          cpf: form.cpf
        })
      });

      const dataPix = await resPix.json();

      if(!resPix.ok || !dataPix.qr_code){
        throw new Error("Erro ao gerar Pix.");
      }

      await guardarPedidoPixel();

      setPix(dataPix);
      setSubmitting(false);
      window.scrollTo(0,0);
      return;
    }

    const res2 = await fetch(CLOUD_RUN_URL,{
      method:"POST",
      headers:{
        "Content-Type":"application/json"
      },
      body: JSON.stringify({
        description,
        preco,
        compra_id: compraId
      })
    });

    if(!res2.ok){
      throw new Error("Erro ao gerar pagamento.");
    }

    const data = await res2.json();

    if(!data.checkout){
      throw new Error("URL de pagamento inválida.");
    }

    await guardarPedidoPixel();

    window.location.href = data.checkout;

  } catch(err){

    console.error(err);

    setError("Não foi possível iniciar o pagamento. Tente novamente.");

    setSubmitting(false);

  }

}

  // Enquanto o QR code do Pix está na tela, pergunta ao backend se já foi pago.
  // Quando aprovar, vai para a página de sucesso (planilha + Pixel), como na volta do Mercado Pago.
  useEffect(()=>{

    if(!pix) return;

    let ativo = true;
    const inicio = Date.now();

    async function verificar(){
      if(!ativo) return;
      try {
        const r = await fetch(CLOUD_RUN_URL,{
          method:"POST",
          headers:{ "Content-Type":"application/json" },
          body: JSON.stringify({ acao:"status", payment_id: pix.payment_id, compra_id: compraId })
        });
        const d = await r.json();
        if(d.pagamento==="approved"){
          ativo = false;
          window.location.href = "/payment-success?external_reference=" + encodeURIComponent(compraId)
            + "&status=approved&payment_id=" + encodeURIComponent(pix.payment_id);
          return;
        }
        if(d.pagamento==="rejected" || d.pagamento==="cancelled"){
          ativo = false;
          setPix(null);
          setError("O Pix expirou ou foi cancelado. Gere um novo para continuar.");
          return;
        }
      } catch(e){}
      // checa a cada 4 s por até 2 horas
      if(ativo && Date.now() - inicio < 2*60*60*1000){
        setTimeout(verificar, 4000);
      }
    }

    const t = setTimeout(verificar, 4000);
    return ()=>{ ativo = false; clearTimeout(t); };

  },[pix]); // eslint-disable-line react-hooks/exhaustive-deps

  async function copiarPix(){
    try {
      await navigator.clipboard.writeText(pix.qr_code);
    } catch(e){
      const el = document.getElementById("pix-codigo");
      if(el){ el.select(); document.execCommand("copy"); }
    }
    setCopiado(true);
    setTimeout(()=>setCopiado(false), 3000);
  }

  if (!kit || !preco) {
    return (
      <div className="checkout-container">
        <div className="checkout-card">
          <h2>Selecione um produto para efetuar a compra</h2>

          <Link to="/" className="back-button">
            Voltar para produtos
          </Link>
        </div>
      </div>
    );
  }

  if (pix) {
    return (
      <div className="checkout-container">
        <div className="checkout-card pix-card">

          <h2>Pague com Pix - R$ {preco}</h2>
          <p className="pix-texto">{description}</p>

          {pix.qr_code_base64 && (
            <img
              className="pix-qr"
              src={"data:image/png;base64," + pix.qr_code_base64}
              alt="QR code do Pix"
            />
          )}

          <p className="pix-texto">Ou copie o código e cole no app do seu banco, em <strong>Pix Copia e Cola</strong>:</p>

          <textarea id="pix-codigo" className="pix-codigo" readOnly value={pix.qr_code} onFocus={(e)=>e.target.select()} />

          <button type="button" onClick={copiarPix}>
            {copiado ? "Código copiado!" : "Copiar código Pix"}
          </button>

          <div className="pix-aguardando">
            <span className="spinner spinner-escuro"></span>
            Aguardando o pagamento... assim que o Pix cair, esta página avança sozinha.
          </div>

        </div>
      </div>
    );
  }

  return(

    <div className="checkout-container">

      <div className="progress">
        <div className="progress-bar"/>
      </div>

      <form className="checkout-card">

        <h2>Finalizar pedido - {description} - R$ {preco}</h2>

        <input name="nome" placeholder="Nome completo" onChange={handleChange} required />
        <input name="celular" type="tel" inputMode="numeric" placeholder="Celular (DDD) 99999-1111" value={form.celular} onChange={handleChange} required />

        <div className="row">

          <input name="cep" placeholder="CEP" value={form.cep} onChange={handleChange} required />
          <input name="numero" placeholder="Número" onChange={handleChange} required />

        </div>

        {loadingCep && <span className="loading">Buscando endereço...</span>}

        <input name="endereco" placeholder="Endereço" value={form.endereco} onChange={handleChange} required />
        <input name="bairro" placeholder="Bairro" value={form.bairro} onChange={handleChange} required />

        <div className="row">

          <input name="cidade" placeholder="Cidade" value={form.cidade} onChange={handleChange} required />

          <select name="estado" value={form.estado} onChange={handleChange} required>

            <option value="">Estado</option>

            {estados.map(uf=>(
              <option key={uf} value={uf}>{uf}</option>
            ))}

          </select>

        </div>

        <input name="email" type="email" placeholder="Email" onChange={handleChange} required />
        <input name="cpf" placeholder="CPF" onChange={handleChange} required />

        {error && (
          <div className="error-box">
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={()=>handleSubmit("pix")}
          disabled={!!submitting}
          className={"btn-pix" + (submitting==="pix" ? " loading-btn" : "")}
        >

        {submitting==="pix" ? (
          <>
            <span className="spinner"></span>
            Gerando Pix...
          </>
        ) : (
          "Pagar com Pix"
        )}

        </button>

        <button
          type="button"
          onClick={()=>handleSubmit("cartao")}
          disabled={!!submitting}
          className={submitting==="cartao" ? "loading-btn" : ""}
        >

        {submitting==="cartao" ? (
          <>
            <span className="spinner"></span>
            Gerando pagamento...
          </>
        ) : (
          "Pagar com cartão ou boleto"
        )}

        </button>

      </form>

    </div>
  )
}